import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Image from './Image';
import ItemInfo from "./ItemInfo";
import IPosModal from '../IPosModal';
import { getImageName } from "../api/iposApi";
import { generateOrderItem } from '../helpers/common';
import ItemQuantity from "../components/ItemQuantiry";
import ItemAddToCardBtn from "../components/ItemAddToCardBtn";
import BlCategoriesList from "../pages/add_item/components/BlCategoriesList"

import './OrderBLItemTest.scss';

function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update the state to force render
}

const OrderBLItemTest = ({ menuItem, currentOrderItem, selectedBusinessLunch, loadMenuItemSupplements, menuItemTypes, currentLanguageId, branchInfo, closeModal, onOk, t }) => {

  const [orderItem, updateOrderItem] = useState(currentOrderItem ? currentOrderItem : menuItem ? generateOrderItem(menuItem, menuItemTypes) : null);
  const [currentQuantity, setCurrentQuantity] = useState(currentOrderItem ? currentOrderItem.orderItem.quantity : 1);
  const [blItems, setBlItems] = useState(orderItem.lunchItems || []);

  const forceUpdate = useForceUpdate();

  useEffect(() => {
    orderItem.lunchItems = blItems;
    updateOrderItem(orderItem);
    forceUpdate();
  }, [blItems]);

  useEffect(() => {
    forceUpdate();
  }, [orderItem]);

  useEffect(() => {
    if (!currentOrderItem) {
      return;
    }
    updateOrderItem(currentOrderItem);
    setBlItems(currentOrderItem.lunchItems);
  }, [currentOrderItem]);

  useEffect(() => {
    const tmpItem = Object.assign({}, orderItem);
    tmpItem.orderItem.quantity = currentQuantity;

    for (const lunchItem of tmpItem.lunchItems) {
      lunchItem.orderItem.quantity = currentQuantity;
      for (const supplement of lunchItem.supplements) {
        supplement.orderItem.quantity = currentQuantity;
      }
    }

    updateOrderItem(tmpItem);
    setBlItems(tmpItem.lunchItems);
  }, [currentQuantity]);

  const mobileLayout = () => {
    return (<div className={ 'test-modal' }>
        <div className={"item-mobile-content"}>
          <div
            className={"close-details-modal"}
            onClick={() => {
              closeModal();
            }}
          >
            <FontAwesomeIcon icon="chevron-down" />
          </div>
            <Image image={getImageName(branchInfo, orderItem.menuItem)} useDefaultEmpty = {true} onClickEvent = {closeModal} />
          <div className={"dialog-item-info"}>
            <ItemInfo
              orderItem={orderItem}
              currentLanguageId={currentLanguageId}
            />
          </div>
          <div className={"item-content"}>
            <BlCategoriesList
              addBlItem={onSelectBlItem}
              selectedItems={blItems}
              selectedBusinessLunch={selectedBusinessLunch}
              menuItemTypes={menuItemTypes}
            />
          </div>                       
        </div>
        <div className={"add-item-actions"}>
          <ItemQuantity
            item={orderItem}
            currentQuantity={currentQuantity}
            updateQuantity={setCurrentQuantity}
          />          
          <ItemAddToCardBtn
            t={t}
            orderItem={orderItem}
            isNewItem={!currentOrderItem}
            onAddToCart={addBlToCart}
          />
        </div>
    </div>);
  };  

  const addBlToCart =  async () => {
    const [valid, error] = await validate();
    if (!valid) {
      showAlert(error);
      return;
    }

    onOk(orderItem);
    goToMenu();
  };

  const updateBlItems = (blItem) => {
    if (
      blItems.some(
        (i) => i.menuItem.menu_item_id === blItem.menuItem.menu_item_id && i.orderItem.business_category_id === blItem.orderItem.business_category_id
      )
    ) {
      if (blItem.noAdditions) {
        deleteBlItem(blItem);
      } else {
        const updatedState = blItems.map((item) => {
          if (item.menuItem.menu_item_id === blItem.menuItem.menu_item_id  && item.orderItem.business_category_id === blItem.orderItem.business_category_id) {
            return Object.assign({}, blItem);
          }
          return item;
        });
        setBlItems([...updatedState]);
      }
    } else {
      setBlItems([...blItems, blItem]);
    }
  };

  const deleteBlItem = (blItem) => {
    setBlItems(
      blItems.filter(
        (i) => !(i.menuItem.menu_item_id === blItem.menuItem.menu_item_id && i.orderItem.business_category_id === blItem.orderItem.business_category_id)
      )
    );
  };

  const onSelectBlItem = (menuItem, category, relation) => {
    const existingLunchItem = blItems.find(
      (i) => i.menuItem.menu_item_id === menuItem.menu_item_id && i.orderItem.business_category_id === category.menu_item_id
    );

    const [maxQtyValid, maxQtyError] = validateMaxCommonQty(1);

    if (!maxQtyValid && !existingLunchItem) {
      showAlert(maxQtyError);
      return;
    }

    const [maxCategoryQtyValid, maxCategoryQtyError] = validateMaxCategoryQty(
      relation.category_item_id,
      1
    );

    if (!maxCategoryQtyValid && !existingLunchItem) {
      showAlert(maxCategoryQtyError);
      return;
    }

    loadMenuItemSupplements(menuItem.menu_item_id).then(
      ([supplements, instructions]) => {
        const noAdditions =
          (!supplements || supplements.length === 0) &&
          (!instructions || instructions.length === 0);

        if (noAdditions) {
          if (existingLunchItem) {
            updateBlItems(existingLunchItem);
          } else {
            updateBlItems(
              generateOrderItem(menuItem, menuItemTypes, {
                noAdditions: true,
                category: category,
                relation: relation,
              })
            );
          }
        } else {
          IPosModal.addItemModal(
            {
              menuItem: menuItem,
              category: category,
              relation: relation,
              currentOrderItem: existingLunchItem,
              t: t,
              isRtl: currentLanguageId === 2,
              selectedItemSupplements: supplements,
              itemInstructions: instructions,
              menuItemTypes: menuItemTypes,
              onlyAdditions: false,
              branchInfo: branchInfo,
              onOk: (lunchItem) => {
                updateBlItems(lunchItem);
              },
              onDelete: (lunchItem) => {
                deleteBlItem(lunchItem);
              },
              onClose: () => {},
            },
            {}
          );
        }
      }
    );
  };

  const showAlert = (message) => {
    IPosModal.alert({
      title: t('add_item_modal.errors.title'),
      message: message,
      okButtonText: t('buttons.ok'),
      cancelButtonText: t('buttons.cancel'),
      onOk: () => {
      }
    });
  };

  const goToMenu = () => {
    //cancelSelection();
    closeModal();
  };

  const validate = async () => {
    const [valid, errorMessage] = validateItemsPresence();
    if (!valid) {
      return [false, errorMessage];
    }

    const [validMin, errorMinMessage] = await validateMinCategoryQty();
    if (!validMin) {
      return [false, errorMinMessage];
    }
    return [true, ''];
  };

  const validateMaxCommonQty = (quantity) => {
    const existingItemsCount = blItems.reduce((acc, curr) => {
      const sum = acc + curr.orderItem.quantity;
      return sum;
    }, quantity);

    return existingItemsCount > maxItemsCount
      ? [false, t("bl.max_items_error", { maxItemsCount: maxItemsCount })]
      : [true, ""];
  };

  // const validateMinCategoryQty = () => {
  //   let denieAddItemFromCategory = false;

  //   selectedBusinessLunch.category_relations.forEach((relation) => {
  //     if (relation.min_qty > 0) {

  //       const existingItemsFromCategoryCount = getItemsQtyInCategory(relation.menu_item_id, 0);

  //       denieAddItemFromCategory = denieAddItemFromCategory || existingItemsFromCategoryCount < relation.min_qty * orderItem.orderItem.quantity;
  //     }
  //   });

  //   return denieAddItemFromCategory
  //     ? [false, t('bl.min_items_error')]
  //     : [true, ''];
  // };

  const validateMinCategoryQty = async () => {    
    for (const relation of selectedBusinessLunch.category_relations) {      
      if (relation.min_qty > 0) {
        const existingItemsFromCategoryCount = getItemsQtyInCategory(relation.menu_item_id, 0);        
        if (existingItemsFromCategoryCount < relation.min_qty * orderItem.orderItem.quantity)
        {
          const category = selectedBusinessLunch.menuItems.find((i) => i.menu_item_id === relation.menu_item_id);
          if (category)
          {
            const message = t('bl.min_items_error', { categoryName: category.item_name });
            return [false, message];
          }
        }
      }      
    }
  
    return [true, ""];    
  };

  const validateMaxCategoryQty = (category_item_id, quantity) => {
    let denieAddItemFromCategory = false;

    selectedBusinessLunch.category_relations.forEach((relation) => {
      if (relation.menu_item_id === category_item_id) {
        const existingItemsFromCategoryCount = getItemsQtyInCategory(
          category_item_id,
          quantity
        );
        denieAddItemFromCategory =
          denieAddItemFromCategory ||
          existingItemsFromCategoryCount >
            relation.max_qty * orderItem.orderItem.quantity;
      }
    });

    return denieAddItemFromCategory
      ? [false, t("bl.category_items_error")]
      : [true, ""];
  };

  const maxItemsCount = orderItem.menuItem.max_childs_count * orderItem.orderItem.quantity;

  const validateItemsPresence = () => {
    return blItems.length === 0
      ? [false, t('bl.bl_not_empty_error')]
      : [true, ''];
  };

  const getItemsQtyInCategory = (categoryId, quantity) => {
    return blItems.reduce(
      (acc, curr) => {
        if (curr.relation.category_item_id === categoryId) {
          return acc + curr.orderItem.quantity;
        }
        return acc;
      },
      quantity);
  };

  return <>{mobileLayout()}</>;
};

export default OrderBLItemTest;
